
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';
import Img from 'theme/components/shared/Img'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "atlas-server-entity-type"
    }}>{`Atlas Server Entity Type`}</h1>
    <h4 {...{
      "id": "background"
    }}>{`Background`}</h4>
    <p>{`The `}<em parentName="p">{`AtlasServer`}</em>{` entity type is special entity type in following ways:`}</p>
    <ul>
      <li parentName="ul">{`Gets created during Export or Import operation.`}</li>
      <li parentName="ul">{`It also has special property pages that display detailed audits for export and import operations.`}</li>
      <li parentName="ul">{`Entities are linked to it using the new option within entity's attribute `}<em parentName="li"><a parentName="em" {...{
            "href": "#/SoftReference"
          }}>{`SoftReference`}</a></em>{`.`}</li>
    </ul>
    <p>{`The new type is available within the `}<em parentName="p">{`Search By Type`}</em>{` dropdown in both `}<em parentName="p">{`Basic`}</em>{` and `}<em parentName="p">{`Advanced`}</em>{` search.`}</p>
    <h4 {...{
      "id": "creation"
    }}>{`Creation`}</h4>
    <p>{`The entity of this type is created upon successful completion of every Export and Import operation. The entity is created with current cluster's name.`}</p>
    <p>{`The entity is also created based on export and import requests' `}<em parentName="p">{`replicatedTo`}</em>{` and `}<em parentName="p">{`replicatedFrom`}</em>{` parameters.`}</p>
    <h4 {...{
      "id": "details-within-property-page"
    }}>{`Details within Property Page`}</h4>
    <p>{`The property page for `}<em parentName="p">{`AtlasServer`}</em>{` entity has one additional tab 'Export/Import Audits'. This has detailed audit record for each export and/or import operation performed on current Atlas instance.`}</p>
    <p>{`The `}<em parentName="p">{`additionalInfo`}</em>{` attribute property is discussed in detail below.`}</p>
    <Img src={`/images/markdown/atlas-server-properties.png`} mdxType="Img" />
    <h4 {...{
      "id": "exportimport-audits"
    }}>{`Export/Import Audits`}</h4>
    <p>{`The table has following columns:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`Operation`}</em>{`: EXPORT or IMPORT that denotes the operation performed on instance.`}</li>
      <li parentName="ul"><em parentName="li">{`Source Server`}</em>{`: For an export operation performed on this instance, the value in this column will always be the cluster name of the current Atlas instance. This is the value specified in `}<em parentName="li">{`atlas-application.properties`}</em>{` by the key `}<em parentName="li">{`atlas.cluster.name`}</em>{`. If not value is specified 'default' is used.`}</li>
      <li parentName="ul"><em parentName="li">{`Target Server`}</em>{`: If an export operation is performed with `}<em parentName="li">{`replicatedTo`}</em>{` property specified in the request, that value appears here.`}</li>
      <li parentName="ul"><em parentName="li">{`Operation StartTime`}</em>{`: Time the operation was started.`}</li>
      <li parentName="ul"><em parentName="li">{`Operation EndTIme`}</em>{`: Time the operation completed.`}</li>
      <li parentName="ul"><em parentName="li">{`Tools`}</em>{`: Pop-up property page that contains details of the operation.`}</li>
    </ul>
    <Img src={'/images/markdown/atlas-server-exp-imp-audits.png'} mdxType="Img" />
    <h4 {...{
      "id": "example"
    }}>{`Example`}</h4>
    <p>{`The following export request will end up creating `}<em parentName="p">{`AtlasServer`}</em>{` entity with `}<em parentName="p">{`clMain`}</em>{` as its name. The audit record of this operation will be displayed within the property page of this entity.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "itemsToExport": [
        { "typeName": "hive_db", "uniqueAttributes": { "qualifiedName": "stocks@cl1" }}
    ],
    "options": {
        "replicatedTo": "clMain"
    }
}`}
    </SyntaxHighlighter>
    <h4 {...{
      "id": "support-for-clusters-full-name"
    }}>{`Support for Cluster's Full Name`}</h4>
    <p>{`Often times it is necessary to disambiguate the name of the cluster by specifying the location or the data center within which the Atlas instance resides.`}</p>
    <p>{`The name of the cluster can be specified by separating the location name and cluster name by '$'. For example, a clsuter name specified as 'SFO$cl1' can be a cluster in San Fancisco (SFO) data center with the name 'cl1'.`}</p>
    <p>{`The `}<em parentName="p">{`AtlasServer`}</em>{` will handle this and set its name as 'cl1' and `}<em parentName="p">{`fullName`}</em>{` as 'SFO@cl1'.`}</p>
    <h4 {...{
      "id": "additional-information"
    }}>{`Additional Information`}</h4>
    <p>{`This property in `}<em parentName="p">{`AtlasServer`}</em>{` is a map with key and value both as String. This can be used to store any information pertaining to this instance.`}</p>
    <p>{`Please see `}<a parentName="p" {...{
        "href": "#/IncrementalExport"
      }}>{`Incremental Export`}</a>{` for and example of how this property can be used.`}</p>
    <h4 {...{
      "id": "rest-apis"
    }}>{`REST APIs`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Title`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Atlas Server API`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Example`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`see below.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`URL`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`api/atlas/admin/server/{serverName}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`URL Parameters`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`name of the server`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Data Parameters`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`None`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Success Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`AtlasServer`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Error Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors Returned as AtlasBaseException`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "curl"
    }}>{`CURL`}</h4>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -X GET -u admin:admin -H "Content-Type: application/json" -H "Cache-Control:no-cache" http://localhost:21000/api/atlas/admin/server/cl2`}
    </SyntaxHighlighter>
    <p>{`Output:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
    "guid": "f87e4fd1-bfb5-482d-9ab1-e735621b7d16",
    "name": "cl2",
    "qualifiedName": "cl2",
    "additionalInfo": {
        "nextModifiedTimestamp": "1533037289383",
        "replicationOperation": "EXPORT",
        "topLevelEntity": "stocks@cl1"
    }
}`}
    </SyntaxHighlighter>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;